module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Fyoutube.b79802c0.svg";